import Vue from 'vue';
import LeaderLine from 'leader-line-vue';

Vue.use(LeaderLine);
